<template>
	<form class="container-sm mh-100 pt-10" @submit.prevent="submit" autocomplete="off">
		<div class="pb-4 vstack gap-3">
			<div class="text-center">
				<router-link :to="{ name: 'home' }" class="d-inline-block">
					<img src="@/assets/img/logo/complete.png" class="h-rem-10" alt="logo">
				</router-link>
			</div>
			<div class="ls-tight lh-sm text-md text-center px-5 px-md-10">Recuperar acceso</div>
			<div class="card text-bg-white border-0 shadow-none">
				<div class="card-body vstack gap-5">
					<div class="vstack gap-3">
						<CommonFormInputEmail v-model="email" title="Email" placeholder="Ingrese su email" :focus="true" :validation="validation.email" />
					</div>
					<div class="text-center d-grid gap-3">
						<button type="submit" class="btn btn-md btn-primary" :disabled="submitting">Recuperar acceso</button>
					</div>
				</div>
			</div>
		</div>
		<div class="text-center fw-bold pb-10">
			¿Ya tienes una cuenta?
			<router-link :to="{ name: 'auth.login' }" class="link-primary ps-2">Ingresar</router-link>
		</div>
	</form>
</template>

<script>
	import { reactive, toRefs } from 'vue';
	import router from '@/router';
	import useVuelidate from '@vuelidate/core';
	import { required, email } from '@/helpers/i18n/validators';
	import composableForm from '@/composables/form';
	import composableRedirect from '@/composables/redirect';

	export default {
		setup() {
			const { submitting } = composableForm();
			const { redirectNext } = composableRedirect();

			const form = reactive({
				email: ''
			});

			const validation = useVuelidate({
				email: {
					required,
					email
				}
			}, form);

			const submit = async () => {
				if(submitting.value) return;
				if(!await validation.value.$validate()) return;

				submitting.value = true;
				router.push({ name: 'auth.recover', query: { email: form.email }});
			}

			return { ...toRefs(form), validation, submitting, submit };
		}
	}
</script>